import React from 'react';
import { Row, Col } from 'antd';
import './index.css';
import wx_01 from '../../static/imgs/wx_01.png';
import wx_02 from '../../static/imgs/wx_02.png';
import wx_code_01 from '../../static/imgs/wx_code_01.png';
import { Menu, Dropdown } from 'antd';
import { Link } from "react-router-dom";
import Download from "../../pages/download/index";
import http from '../../http/http';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wxSrc: props.themeStyle == "1" ? wx_02 : wx_01
    }
  }
  render () {
    let wechartCode = (
      <Menu>
        <Menu.Item key="item_01">
          <div style={{ width: "140px", height: "140px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img src={wx_code_01} style={{ width: "100%", height: "100%" }}></img>
          </div>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className='home_footer box-padding-horizontal' themestyle={this.props.themeStyle ? this.props.themeStyle : "0"} style={{ paddingLeft: this.props.paddingLeft ? this.props.paddingLeft : "" }}>
        <Download ref="download"></Download>
        <div className="home_footer_content pc-show">
          <div className="left">
            <Row gutter={[16, 16]}>
              <Col md={24} lg={8}>
                <div className="col">
                  <div className="title">下载</div>
                  <div className="text hover_text">
                    <Link className="link" to={"/words/运行原型"}></Link>
                    客户端有什么用
                  </div>
                  <div className="text hover_text" onClick={this.showDownload.bind(this, 2)}>
                    Android客户端
                  </div>
                  <div className="text hover_text" onClick={this.showDownload.bind(this, 1)}>iOS客户端</div>
                </div>
              </Col>
              <Col md={24} lg={8}>
                <div className="col">
                  <div className="title">关于</div>
                  <div className="text hover_text">
                    <Link className="link" to={"/words/使用条款"}></Link>
                    使用条款
                  </div>
                  <div className="text hover_text">
                    <Link className="link" to={"/words/隐私政策"}></Link>
                    隐私政策
                  </div>
                </div>
              </Col>
              <Col md={24} lg={8}>
                <div className="col">
                  <div className="title hover_text">联系我们</div>
                  <div className="text hover_text">
                    <Link className="link" to={"/feedback"}></Link>
                    问题反馈
                  </div>
                  <div className="text hover_text">电话: 0731-88922622</div>
                  <div className="text hover_text">邮箱: cyberui@cyberwise.com.cn</div>
                  {/* <div className="text hover_text">QQ群: 557962456</div> */}
                </div>
              </Col>
              <Col span={24}>
                <div className="col">
                  <div className="text">Powered By <a href="http://www.cyberwise.com.cn" target="_blank">Cyberwise Tech Co., Ltd</a></div>
                  <div className="text">工信部备案号:<a href="https://beian.miit.gov.cn" target="_blank">湘ICP备09003896号-3</a></div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="line"></div>
          <div className="right">
            <Row>
              <Col md={24} lg={24} style={{ height: "50%" }}>
                <div className="col">
                  <div className="title" style={{ fontSize: "24px" }}>赛百UI</div>
                  <div className="text">支持终端适配的高保真原型设计工具</div>
                  <div className="text build">版本号: {
                    window.IDEConfig ? window.IDEConfig.BUILD_VERSION : ""
                  }</div>
                  <div className="col">
                    <Dropdown overlay={wechartCode} placement="topCenter" arrow>
                      <div className="lineIcon" onMouseEnter={this.wxMouseEnter.bind(this)} onMouseLeave={this.wxMouseLeave.bind(this)}>
                        <img src={this.state.wxSrc}></img>
                      </div>
                    </Dropdown>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="home_footer_content mobile-show">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24}>
              <div className="col">
                <div className="title">下载</div>
                <div className="text hover_text">
                  <Link className="link" to={"/words/运行原型"}></Link>
                  客户端有什么用
                </div>
                <div className="text hover_text" onClick={this.showDownload.bind(this, 2)}>
                  Android客户端
                  </div>
                <div className="text hover_text" onClick={this.showDownload.bind(this, 1)}>iOS客户端</div>
              </div>
            </Col>
            <Col xs={24} sm={24}>
              <div className="col">
                <div className="title">关于</div>
                <div className="text hover_text">
                  <Link className="link" to={"/words/使用条款"}></Link>
                  使用条款
                </div>
                <div className="text hover_text">
                  <Link className="link" to={"/words/隐私政策"}></Link>
                  隐私政策
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24}>
              <div className="col">
                <div className="title hover_text">联系我们</div>
                <div className="text hover_text">
                  <Link className="link" to={"/feedback"}></Link>
                  问题反馈
                </div>
                <div className="text hover_text">电话: 0731-88922622</div>
                <div className="text hover_text">邮箱: cyberui@cyberwise.com.cn</div>
                {/* <div className="text hover_text">QQ群: 557962456</div> */}
              </div>
            </Col>
            <Col span={24}>
              <div className="col">
                <div className="text">Powered By <a href="http://www.cyberwise.com.cn" target="_blank">Cyberwise Tech Co., Ltd</a></div>
                <div className="text">工信部备案号:<a href="https://beian.miit.gov.cn" target="_blank">湘ICP备09003896号-3</a></div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
  showDownload (clientType) {
    // if (this.refs.download) {
    //   // this.refs.download.showDownload();
    // }
    window.location.href = http.hostUrl + http.contextName + "/pages/download.html?clientType=" + clientType;
  }
  wxMouseLeave () {
    if (this.props.themeStyle == "1") {
      this.setState({
        wxSrc: wx_02
      });
    } else {
      this.setState({
        wxSrc: wx_01
      });
    }
  }
  wxMouseEnter () {
    if (this.props.themeStyle == "1") {
      this.setState({
        wxSrc: wx_01
      });
    } else {
      this.setState({
        wxSrc: wx_02
      });
    }
  }
}

export default Footer;